import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Bredcom from '../components/Bredcom/Bredcom';
import Footer from '../components/Footer/Footer';

function Studenti () {
    return (
        <>
        <Navbar/>
        <Bredcom title="Početna" subtitle="Studenti" />
        <Footer />
        </>
    )
}
export default Studenti;